import { useState } from 'react';
import { Alert, Button, Space, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import ApiService from '../../core/service/api-service';
import DatePicker from '../../core/components/DatePicker';
import { LocalStorageService } from '../../core/service/local-storage-service';

// Sunucudaki StudyDataExportLimits ile aynı olmalı.
const MAX_STUDY_COUNT = 10;
const DEFAULT_LOG_WINDOW_MONTHS = 2;

// Çekim veri export'u: seçili çekimlerin tüm verisi tek ZIP (manifest + çekim başına study.json + dosyalar).
// Uygulama log penceresi her çekimin geliş anında başlar; bitiş boşsa geliş + 2 ay, kullanıcı ileri atabilir.
export default function StudyDataExportModal({ studies = [], onClose }) {
    const { t } = useTranslation();
    const [logEndDate, setLogEndDate] = useState(null);

    const tooMany = studies.length > MAX_STUDY_COUNT;

    const download = async () => {
        const response = await ApiService.Study.ExportData({
            studyIdList: studies.map((x) => x.id),
            logEndDate: logEndDate ? logEndDate.clone().endOf('day').toISOString() : null,
        });

        if (response.success) {
            ApiService.downloadFile(response.data, response.fileName);
            onClose && onClose();
        }
    };

    return (
        <div style={{ padding: '16px 0' }}>
            <Space direction="vertical" style={{ width: '100%' }}>
                <Typography.Text>
                    {t('STUDY_DATA_EXPORT_SELECTED', { count: studies.length })}
                </Typography.Text>

                {tooMany && (
                    <Alert
                        type="error"
                        showIcon
                        message={t('STUDY_DATA_EXPORT_MAX_STUDY')}
                    />
                )}

                <div>
                    <Typography.Text strong>{t('STUDY_DATA_EXPORT_LOG_END')}</Typography.Text>
                    <div style={{ marginTop: 4 }}>
                        <DatePicker
                            locale={LocalStorageService.getAntLocale()}
                            value={logEndDate}
                            allowClear
                            showToday={false}
                            placeholder={t('STUDY_DATA_EXPORT_LOG_END_DEFAULT', { months: DEFAULT_LOG_WINDOW_MONTHS })}
                            style={{ width: 260 }}
                            disabledDate={(date) => date && date.isAfter(moment().endOf('day'))}
                            onChange={(date) => setLogEndDate(date)}
                        />
                    </div>
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                        {t('STUDY_DATA_EXPORT_LOG_END_DESC', { months: DEFAULT_LOG_WINDOW_MONTHS })}
                    </Typography.Text>
                </div>
            </Space>

            <div style={{ marginTop: 16, textAlign: 'right' }}>
                <Space>
                    <Button onClick={onClose}>{t('Cancel')}</Button>
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        disabled={studies.length === 0 || tooMany}
                        onClick={download}
                    >
                        {t('Download')}
                    </Button>
                </Space>
            </div>
        </div>
    );
}
